import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'blankOrNA'
})
export class BlankOrNAPipe implements PipeTransform {
  transform(value: string | null | undefined, fallback: string = 'N/A'): string {
    const trimmed = value?.trim();
    return trimmed ? trimmed : fallback;
  }
}
